export const getResolution = (): string => {
    return `${window.innerHeight}x${window.innerWidth}`
}
